import { CoreIcon } from '../core-icon';
import licensePlateSVG from '../../../src/images/icons/license-plate.svg';

export const LicensePlateIcon = props => {
  return <CoreIcon src={licensePlateSVG} {...props} />;
};
